module.exports = __webpack_public_path__ + "static/Lesson-72070c258b7f3790712da0523daca0c3.png";